var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds',{attrs:{"ds":"button","label":_vm.$t('component.ConnectMetamask.connect'),"iconSize":"1rem","isReverse":"true","version":_vm.version,"icon":"open-to-right","isDisabled":_vm.isDisabled,"isLoading":_vm.isSigning},on:{"click":_vm.handleConnect}})
}
var staticRenderFns = []

export { render, staticRenderFns }